import { render, staticRenderFns } from "./AppDetails.vue?vue&type=template&id=59a92e62&scoped=true&"
import script from "./AppDetails.vue?vue&type=script&lang=js&"
export * from "./AppDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppDetails.vue?vue&type=style&index=0&id=59a92e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a92e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a92e62')) {
      api.createRecord('59a92e62', component.options)
    } else {
      api.reload('59a92e62', component.options)
    }
    module.hot.accept("./AppDetails.vue?vue&type=template&id=59a92e62&scoped=true&", function () {
      api.rerender('59a92e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/components/AppDetails.vue"
export default component.exports